import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdaptCommonProgressModule } from "@common/progress/common-progress.module";
import { AdaptToolbarModule } from "@common/shell/toolbar/toolbar.module";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AdaptToolsModule } from "app/features/tools/tools.module";
import { DxSortableModule, DxTagBoxModule } from "devextreme-angular";
import { AddProgressToOrganisationDialogComponent } from "./add-progress-to-organisation-dialog/add-progress-to-organisation-dialog.component";
import { ProgressListPageComponent, progressListPageRoute } from "./progress-list-page/progress-list-page.component";


@NgModule({
    declarations: [
        AddProgressToOrganisationDialogComponent,
        ProgressListPageComponent,
    ],
    imports: [
        CommonModule,
        AdaptCommonProgressModule,
        AdaptToolbarModule,
        AdaptButtonModule,
        AdaptCommonDialogModule,
        AdaptToolsModule,
        DxSortableModule,
        DxTagBoxModule,
        AdaptTooltipModule,
    ],
})
export class AdaptNimbusProgressModule {
    public static readonly Routes = [
        ...progressListPageRoute.routes,
    ];
}
